import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import PropTypes from 'prop-types';

const GroupOptionsDrawer = props => (
  <Drawer
    open={props.isOpen}
    anchor="bottom"
    onClose={props.hideMenu}
    data-testid="group-options-drawer"
  >
    <button
      className="ad-option view-content-button"
      onClick={props.handleViewContent}
    >
      View Content
    </button>
  </Drawer>
);

export default GroupOptionsDrawer;

GroupOptionsDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleViewContent: PropTypes.func.isRequired,
  handleEditAd: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  hideMenu: PropTypes.func.isRequired
};
